module.exports = __webpack_public_path__ + "static/media/soundOff_btn.be262dd1.png";